import {MouseEvent} from 'react'
import cn from 'clsx'

import './CheckButton.scss'
import {IconButton, EmptyCircleIcon, CheckedCircleIcon} from 'common/components'

interface CheckButtonProps {
  className?: string
  checked: boolean
  disabled?: boolean
  onClick?: (e: MouseEvent) => void
}

export default function CheckButton({
  checked,
  onClick,
  ...props
}: CheckButtonProps) {
  return (
    <IconButton
      {...props}
      noClick={!onClick}
      icon={
        <div
          className={cn(
            'CheckButton-Wrapper',
            checked && 'CheckButton-Wrapper_checked'
          )}
        >
          <EmptyCircleIcon />
          <CheckedCircleIcon className="CheckButton-Icon" />
        </div>
      }
      onClick={checked ? undefined : onClick}
    />
  )
}
